<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="page-hero-title mt-3">Question Templates</h1>
                    <p class="sub-text mt-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                        specimen book.
                    </p>
                    <div class="mt-5">
                        <button class="btn btn-success btn-lg px-5 text-uppercase" type="button" data-toggle="modal" data-target="#callBack" id="callback">REQUEST A DEMO</button>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100" alt="market Survey" src="assets/templates.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>




    <section class="mt-5">
        <div class="py-lg-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <div class="sidebox-aside-menu sticky-section">
                            <div class="card">
                                <div class="card-header">
                                    <div class="header-heading">Industries Templates</div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="aside-vertical-tabs nav flex-column nav-pills" role="tablist">
                                        <a class="nav-link active" data-toggle="pill" href="#temp-healthcare" role="tab" aria-controls="v-pills-home" aria-selected="true">Healthcare</a>
                                        <a class="nav-link" data-toggle="pill" href="#temp-education" role="tab" aria-controls="v-pills-profile" aria-selected="false">Education</a>
                                        <a class="nav-link" data-toggle="pill" href="#ite-ites" role="tab" aria-controls="v-pills-messages" aria-selected="false">IT &
                                            ITES</a>
                                        <a class="nav-link" data-toggle="pill" href="#temp-hotel-restaurent" role="tab" aria-controls="v-pills-messages" aria-selected="false">Hotel
                                            &
                                            Restaurants</a>
                                        <a class="nav-link" data-toggle="pill" href="#event-entertainment" role="tab" aria-controls="v-pills-messages" aria-selected="false">Event
                                            &
                                            Entertainment</a>
                                        <a class="nav-link" data-toggle="pill" href="#retail-manufacturing" role="tab" aria-controls="v-pills-messages" aria-selected="false">Retail
                                            and
                                            Manufacturing</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="temp-healthcare" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/healthcare.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Health and Wellness Survey Template
                                                    </h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">10 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="temp-education" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/education.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Student Feedback Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="ite-ites" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/itites.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Customer Demographics Survey Template Customer Demographics Survey Template Customer Demographics Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="temp-hotel-restaurent" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/hote-restaurent.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Restaurant Feedback Form Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="event-entertainment" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/event-entertainment.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Post Event Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="retail-manufacturing" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row">
                                    <div class="col-lg-4 mb-lg-4">
                                        <div class="card survey-template-card" routerLink="/templates-question-details">
                                            <img class="card-img-top" src="assets/templates/retail-store-evaluation.jpg" alt="Card image cap">
                                            <div class="survey-template-card-overlay">
                                                <div class="card-body survey-template-card-body">
                                                    <h5 class="survey-template-card-title">Retail Store Evaluation Survey Template</h5>
                                                    <div class="survey-template-card-details">
                                                        <p class="survey-template-card-subtitle">9 Question</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>
<app-footer></app-footer>